import { userEventModule } from "user/event"
import { refreshPages } from "./tools/common"

export const startPageListeners = (): void => {
  refreshPages() // will create routes
  userEventModule.on.login("campaign-login", ({ userInfo }) => {
    refreshPages(userInfo)
  })
}
